import { render, staticRenderFns } from "./EnrollDetail.vue?vue&type=template&id=6f3240a9&scoped=true&"
import script from "./EnrollDetail.vue?vue&type=script&lang=js&"
export * from "./EnrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnrollDetail.vue?vue&type=style&index=0&id=6f3240a9&prod&scoped=true&lang=css&"
import style1 from "./EnrollDetail.vue?vue&type=style&index=1&id=6f3240a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3240a9",
  null
  
)

export default component.exports